// Thin wrapper around authenticatedFetch. Mirrors Offboarding/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/users';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try {
      const raw = await resp.text();
      try {
        const j = JSON.parse(raw);
        detail = typeof j === 'string' ? j : j.detail ? String(j.detail) : raw;
      } catch {
        detail = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240);
      }
    } catch { /* status alone is enough */ }
    throw new Error(`${resp.status} ${resp.statusText}${detail ? `: ${detail}` : ''}`);
  }
  return resp.json();
}

export const usersApi = {
  list: () => authenticatedFetch(BASE).then(jsonOrThrow),

  create: (body) =>
    authenticatedFetch(BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(jsonOrThrow),

  update: (id, body) =>
    authenticatedFetch(`${BASE}/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(jsonOrThrow),

  // Admins only. tool filters by tool id; before is the id of the last entry already shown.
  activity: (id, { tool, before, limit = 25 } = {}) => {
    const q = new URLSearchParams({ limit });
    if (tool) q.set('tool', tool);
    if (before) q.set('before', before);
    return authenticatedFetch(`${BASE}/${id}/activity?${q}`).then(jsonOrThrow);
  },

  resendSetupLink: (id) =>
    authenticatedFetch(`${BASE}/${id}/resend-setup-link`, { method: 'POST' }).then(jsonOrThrow),
};
